import { ReactComponent as FbIcon } from './facebook-footer.svg';
import { ReactComponent as InstagramIcon } from './instagram-footer.svg';
import { ReactComponent as LinkedInIcon } from './linkedin-footer.svg';
import { ReactComponent as TwitterIcon } from './twitter-footer.svg';
import { ReactComponent as TiktokIcon } from './tiktok-footer.svg';
import { ReactComponent as YoutubeIcon } from './youtube-footer.svg';

export type SocialPlatform =
  | 'facebook'
  | 'twitter'
  | 'linkedin'
  | 'instagram'
  | 'tiktok'
  | 'youtube';

type IconMap = Record<SocialPlatform, React.FC<React.SVGProps<SVGSVGElement>>>;

export const SocialIcons: Partial<IconMap> = {
  facebook: FbIcon,
  instagram: InstagramIcon,
  linkedin: LinkedInIcon,
  twitter: TwitterIcon,
  tiktok: TiktokIcon,
  youtube: YoutubeIcon,
};

export const getClientIcons = (): Partial<IconMap> => SocialIcons;
